App.namespace.wrap('components.room_pricing_table', ($pricingTable, sectionType, options = {}) => {
  const $days = $pricingTable.findMany('.c-pricing-table__day');

  const $opened = $pricingTable.findAny('.c-pricing-table__day.c-pricing-table__day--expanded');
  let $active = $opened.length === 1 ? $opened : null;

  const hideRow = ($el, { immediate } = {}) => {
    const $body = $el.findOne('.c-pricing-table__body');

    if (immediate) {
      $el.removeClass('c-pricing-table__day--expanded');
      $body.hide();
      return;
    }

    $el.addClass('c-pricing-table__day--removing');
    $el.removeClass('c-pricing-table__day--removing c-pricing-table__day--expanded');
    $body.slideUp(300);
  };

  const showRow = ($el, { initial } = {}) => {
    // if day is closed don't open it.
    if ($el.hasClass('c-pricing-table__day--closed')) {
      return;
    }

    if ($active) {
      hideRow($active, { immediate: true });
      $active = null;
    }

    const $body = $el.findOne('.c-pricing-table__body');

    $el.addClass('c-pricing-table__day--expanding c-pricing-table__day--expanded');

    if ($el[0].scrollIntoViewIfNeeded && !initial) {
      const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
      $el[0].scrollIntoViewIfNeeded(isMobile);
    }

    $body.slideDown(300, () => {
      $el.removeClass('c-pricing-table__day--expanding');
    });

    $active = $el;
  };

  const showDate = (date, options = {}) => {
    showRow(
      $pricingTable.findOne(`.c-pricing-table__day[data-day-of-week="${date}"]`),
      options,
    );
  };

  $days.on('click', '.c-pricing-table__row--header', (event) => {
    const $el = $(event.delegateTarget);

    if ($active && $active.is($el)) {
      hideRow($el);
      $active = null;
      return;
    }

    options?.onRowClick?.($el);

    showRow($el);

    if (window.App.views.shared?.fixTooltips) {
      window.App.views.shared.fixTooltips({repaint: 1, container: $el.get(0), force: 1});
    }
  });

  /**
   * Data tracking
   */
  $pricingTable.on('click', '.c-pricing-table__row--header', e => {
    const $row = $(e.currentTarget);
    const name = $row.findOne('.c-pricing-table__item--package, .c-pricing-table__item--day')
      .text()
      .trim();
    const type = e.delegateTarget.dataset.type;

    App.track.all({
      category: 's-room-pricing',
      action: 'row-clicked',
      label: type,
      value: name,
    });
  });

  if (sectionType === 'pricing' && window.__TGV_ROOM_DEFAULT_DATE) {
    showDate(window.__TGV_ROOM_DEFAULT_DATE, { initial: true });
  }

  return {
    showDate,
  };
});
